import { PickerCallback } from "react-google-drive-picker/dist/typeDefs";
import {
  DASHBOARD_ENTITIES,
  FILE_UPLOAD_ERRORS,
  GRAPH_COLOR_GRADIENTS,
  MimeTypes,
} from "../../common/constants";
import { clauseCheckDocStatus } from "./constants";
import { ClauseCheckObjectType } from "./types";
import { IFillTextToCanvas } from "../../components/Graphs/Graphs.types";

export const getFileNameWithoutExtension = (fileName: string) => {
  const words = fileName?.split(".");
  if (Array.isArray(words) && words.length > 0) {
    words.pop();
    return words.join();
  }
  return fileName;
};

export const addDocExtentionIfMissing = (file: any) => {
  const fileName = file?.name || file?.file_name || file?.doc?.name;
  const isPdf = fileName.endsWith(".pdf");
  const isDocOrDocx = fileName.endsWith(".doc") || fileName.endsWith(".docx");

  if (isPdf || isDocOrDocx) return fileName;
  else if ((file.mimeType || file.type) === MimeTypes.pdf)
    return `${fileName}.pdf`;
  else return `${fileName}.docx`;
};

export const getUnReviewedDocuments = (docs: ClauseCheckObjectType[]) => {
  const unreviewedFiles = docs?.filter(
    (doc: ClauseCheckObjectType) =>
      doc.status !== clauseCheckDocStatus.CLAUSE_CHECK_READY
  );
  return unreviewedFiles?.length > 0;
};

export const handleValidationForDashboardEntity = (body: {
  entity: string;
  data: PickerCallback;
}) => {
  const { entity, data } = body;
  const docs = data?.docs;
  let errorMessage = "";
  let isSomeNonSupportedFileFormatPresent = [];
  switch (entity) {
    case DASHBOARD_ENTITIES.CLAUSE_CHECK:
      // const moreDocsSelectedThenLimit =
      //   docs?.length > FILES_LIMIT_FROM_DRIVE_UPLOAD;
      // if (moreDocsSelectedThenLimit) {
      //   errorMessage += FILE_UPLOAD_ERRORS.NUMBER_OF_FILES_LIMIT_REACHED;
      // }
      // isSomeNonSupportedFileFormatPresent = docs?.filter((file: any) => {
      //   return file.mimeType !== MimeTypes.pdf;
      // });

      // if (
      //   isSomeNonSupportedFileFormatPresent &&
      //   isSomeNonSupportedFileFormatPresent?.length > 0
      // )
      //   errorMessage += " " + FILE_UPLOAD_ERRORS.ONLY_PDFS_ARE_SUPPORTED;
      break;
    case DASHBOARD_ENTITIES.CONTRACT_REVIEW:
      isSomeNonSupportedFileFormatPresent = docs?.filter((file: any) => {
        return file.mimeType === MimeTypes.pdf;
      });
      if (
        isSomeNonSupportedFileFormatPresent &&
        isSomeNonSupportedFileFormatPresent?.length > 0
      )
        errorMessage += FILE_UPLOAD_ERRORS.PDF_IS_NOT_SUPPORTED;
      break;
    case DASHBOARD_ENTITIES.CONTRACT_DRAFTING:
      break;

    case DASHBOARD_ENTITIES.RFX_EVALUATION:
      break;

    default:
      break;
  }
  return errorMessage;
};

export const getShades = (count: number) => {
  const keys = Object.keys(
    GRAPH_COLOR_GRADIENTS
  ) as (keyof typeof GRAPH_COLOR_GRADIENTS)[];
  let allShades: string[] = [];
  keys.forEach((key) => {
    allShades = allShades.concat(GRAPH_COLOR_GRADIENTS?.[key]);
  });
  return allShades.slice(0, count).reverse();
};

export const wrapText = function ({
  ctx,
  text,
  x,
  y,
  maxWidth,
  lineHeight,
}: any) {
  let words = text.split(" ");
  let line = "";
  let testLine = "";
  let lineArray = [];

  for (var n = 0; n < words.length; n++) {
    testLine += `${words[n]} `;
    let metrics = ctx.measureText(testLine);
    let testWidth = metrics.width;
    if (testWidth > maxWidth && n > 0) {
      lineArray.push([line, x, y]);
      y += lineHeight;
      line = `${words[n]} `;
      testLine = `${words[n]} `;
    } else {
      line += `${words[n]} `;
    }
    if (n === words.length - 1) {
      lineArray.push([line, x, y]);
    }
  }
  return lineArray;
};

export const fillTextToCanvas = ({
  ctx,
  font,
  color,
  text,
  x,
  y,
}: IFillTextToCanvas) => {
  ctx.save();
  ctx.font = font;
  ctx.fillStyle = color;
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.fillText(text, x, y);
};
